exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card {\n  top: 85px;\n  width: 65%;\n  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08);\n  margin-right: auto;\n  margin-left: auto;\n  border: solid;\n  border-width: 1px;\n  border-color: #f7f7f7; }\n\n.card-header {\n  height: 40px;\n  padding: 6px !important;\n  background-color: #f7f7f7; }\n\n.card-title {\n  font-size: 16px;\n  font-weight: normal;\n  margin-bottom: 0;\n  padding-top: 6px;\n  padding-left: 10px; }\n\n.card-block {\n  padding: 0; }\n\n.modal-dialog {\n  min-width: 400px; }\n\n.modal-header-alerta {\n  padding-top: 11px !important;\n  padding-bottom: 11px !important; }\n\n.modal-footer-alerta {\n  text-align: center !important;\n  border-top: 1px solid #f0f0f0; }\n\n.modal-footer-alerta > .btn-link {\n  text-transform: none; }\n\n.modal-body {\n  font-size: 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/manipula-cadastro/manipula-cadastro.component.scss
// module id = ../../../../../src/app/angular-base-ui/manipula-cadastro/manipula-cadastro.component.scss
// module chunks = 1